import { createApp } from "vue";
import { useFavicon } from '@vueuse/core'
import App from "./App.vue";
import router from "./router";
import BootstrapVueNext from "bootstrap-vue-next";
import VueApexCharts from "vue3-apexcharts";
import { QuillEditor } from '@vueup/vue-quill'
import Vue3Prism from 'vue3-prism/lib/Vue3Prism.common.js'
import vueCountryRegionSelect from 'vue3-country-region-select'

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "swiper/css";
import "swiper/css/bundle";
import 'flatpickr/dist/flatpickr.css';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@vueup/vue-quill/dist/vue-quill.bubble.css';
import "vue3-prism/lib/Vue3Prism.css";
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

import { i18n, setDayjsLocale } from "@/assets/i18n/i18n";

import "./assets/custom.scss";
import(`./assets/env/${process.env.VUE_APP_CLIENT}/env.scss`);

import VueDraggableNext from "vuedraggable";
import dayjs from "dayjs";

var customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

const icon = require(`./assets/env/${process.env.VUE_APP_CLIENT}/images/favicon.svg`);
useFavicon(icon);

const app = createApp(App).use(router);
app.use(VueApexCharts);
app.use(VCalendar, {});
app.use(BootstrapVueNext);
app.component("DraggableList", VueDraggableNext);
app.use(vueCountryRegionSelect);
app.use(i18n);
setDayjsLocale();
app.component('QuillEditor', QuillEditor)
.use(Vue3Prism)
app.mount("#app");
